// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2UN-y","colMaxWidth":"Table_colMaxWidth__1ZZuW"};